import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../../contexts/AuthContext";

const EditStageModal = ({ stage, onClose, onSuccess }) => {
  const [name, setName] = useState(stage.name);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { apiBaseUrl } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setMessage("لطفاً نام استیج را وارد کنید");
      return;
    }

    if (name.trim() === stage.name) {
      setMessage("تغییری در نام استیج ایجاد نشده است");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await axios.put(
        `${apiBaseUrl}/api/tournament/admin/stages/${stage.id}`,
        { name: name.trim() },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      setMessage("استیج با موفقیت به‌روزرسانی شد");

      // بعد از 1 ثانیه مودال رو ببند و لیست رو رفرش کن
      setTimeout(() => {
        onSuccess();
      }, 1000);
    } catch (error) {
      console.error("Error:", error);
      setMessage(error.response?.data?.message || "خطا در به‌روزرسانی استیج");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg max-w-md w-full">
        <div className="flex justify-between items-center p-4 border-b border-gray-600">
          <h3 className="text-lg font-semibold text-white">ویرایش استیج</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white text-2xl w-8 h-8 flex items-center justify-center"
          >
            ×
          </button>
        </div>

        <div className="p-6">
          {message && (
            <div
              className={`p-4 rounded-lg text-center mb-4 ${
                message.includes("موفقیت")
                  ? "bg-green-900 border border-green-600 text-green-400"
                  : "bg-red-900 border border-red-600 text-red-400"
              }`}
            >
              {message}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-400 text-sm mb-2">
                ID استیج:
              </label>
              <input
                type="text"
                value={stage.id}
                disabled
                className="w-full p-3 bg-gray-900 border border-gray-600 rounded-lg text-gray-500 cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block text-white font-medium mb-2">
                نام استیج:
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="مثال: Speed Run Challenge 2"
                className="w-full p-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:border-yellow-500 focus:outline-none"
              />
            </div>

            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 py-3 px-6 bg-gray-600 hover:bg-gray-700 text-white font-medium rounded-lg transition duration-200"
              >
                انصراف
              </button>
              <button
                type="submit"
                disabled={loading || !name.trim()}
                className="flex-1 py-3 px-6 bg-yellow-600 hover:bg-yellow-700 disabled:bg-gray-600 text-white font-medium rounded-lg transition duration-200 flex items-center justify-center gap-2"
              >
                {loading ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                    در حال ذخیره...
                  </>
                ) : (
                  "ذخیره تغییرات"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditStageModal;
